import { jsxs, jsx } from 'react/jsx-runtime';
import { useBreakpoint } from '@sketch/components';
import '../Arrow/index.js';
import '../Icon/index.js';
import { MobileContainer, MobileDescription, Container, Content, Column, Title, Description, ButtonContainer, StyledLink, StyledLinkButton, Note, Diamond } from './Banner.styles.js';
import '../../hooks/index.js';
import { useTrackEventInView } from '../../hooks/useTrackEventInView.js';
import { useTrackEvent } from '../../hooks/useTrackEvent.js';
import Icon from '../Icon/Icon.js';
import Arrow from '../Arrow/Arrow.js';

/**
 *
 * Banner
 *
 * This components renders the Banner item in the Discover page.
 * Used to render the Latest Release content
 */
const Banner = props => {
    const { title, content, links, note, mobile } = props;
    // Analytics
    const { ref } = useTrackEventInView('DISCOVER - Banner', {
        type: 'load',
        target: title,
    });
    const { trackEvent } = useTrackEvent();
    const isMobile = !useBreakpoint('xs');
    // Mobile UI changes drastically so we are rendering a different content here
    if (isMobile && mobile) {
        return (jsxs(MobileContainer, { children: [mobile.icon && jsx(Icon, { name: mobile.icon, size: "32px" }), jsx(MobileDescription, { children: mobile === null || mobile === void 0 ? void 0 : mobile.description })] }));
    }
    const buttonLinks = links === null || links === void 0 ? void 0 : links.filter(link => !!link.variant);
    const inlineLinks = links === null || links === void 0 ? void 0 : links.filter(link => !link.variant);
    return (jsxs(Container, Object.assign({ ref: ref }, { children: [jsxs(Content, { children: [jsxs(Column, { children: [jsx(Title, { children: title }), jsx(Description, { children: content }), jsx(ButtonContainer, { children: inlineLinks === null || inlineLinks === void 0 ? void 0 : inlineLinks.map((link, index) => (jsxs(StyledLink, Object.assign({ href: link.url, target: "_blank", variant: "secondary", onClick: () => {
                                        trackEvent('DISCOVER - Banner', {
                                            type: 'click',
                                            target: link.text,
                                        });
                                    }, external: true, isUnderlined: true }, { children: [link.text, jsx(Arrow, {})] }), `${index}+${link.text}`))) })] }), jsxs(Column, { children: [jsx(ButtonContainer, { children: buttonLinks === null || buttonLinks === void 0 ? void 0 : buttonLinks.map((link, index) => (jsx(StyledLinkButton, Object.assign({ variant: link.variant || 'primary-untinted', target: "_blank", href: link.url, onClick: () => {
                                        trackEvent('DISCOVER - Banner', {
                                            type: 'click',
                                            target: link.text,
                                        });
                                    }, external: true, fill: true, size: "32" }, { children: link.text }), `${index}+${link.text}`))) }), jsx(Note, { children: note })] })] }), jsx(Diamond, {})] })));
};

export { Banner as default };
